// Versión de `features/niko` para las builds que NO incluyen la funcionalidad.
//
// El Dockerfile del frontend copia este archivo sobre `index.js` y borra las carpetas de
// Niko cuando se construye la imagen core (ver ARG NIKO_ENABLED). Exporta exactamente
// los mismos nombres que la versión real, en su forma vacía, para que el resto de la app
// compile sin cambios y sin condicionales desparramados.
//
// Si agregás algo a `index.js`, tiene que existir acá también: la build del core falla
// en el `docker build` si falta, que es donde uno quiere enterarse.

/** ¿Esta build incluye Niko? Acá, nunca. */
export const NIKO_ENABLED = false;

// Los textos se apagan reemplazando `strings.js` por su versión vacía, no desde este
// archivo: `utils/translation.js` los importa directo (ver el comentario de allá).

/** Sin entrada en el menú lateral. */
export const nikoMenuItem = () => null;

/** Sin rutas: `/niko` cae en el `Redirect` a HOME del router, como cualquier ruta ajena. */
export const nikoRoutes = () => [];
